import CircularFilledIcon from "@/components/CircularButton/styled/CircularFilledIcon";
import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import { FlexRowAlignCenter } from "@/components/Flex";
import { useUpgradePopupContextSelector } from "@/features/Payments/PaywallPopup/UpgradePopupContext";
import { borderRadius } from "@/utils/borderRadius";
import { spacing } from "@/utils/spacing";
import { themeColors } from "@/utils/themeColors";
import { ItemType, UpgradeEvent } from "@knowt/syncing/graphql/schema";
import { SparkleIcon, X } from "lucide-react";

export const KAI_COMPLETE_UPGRADE_BANNER_PREFIX_KEY = "KAI_COMPLETE_UPGRADE_BANNER";

const KaiCompleteUpgradeBanner = ({
    isOpen,
    onClose,
    itemId,
    itemType,
    style,
}: {
    isOpen: boolean;
    onClose: () => void;
    itemId: string;
    itemType: ItemType;
    style?: React.CSSProperties;
}) => {
    const openUpgradePopup = useUpgradePopupContextSelector(s => s.openUpgradePopup);

    if (!isOpen) return null;

    return (
        <FlexRowAlignCenter
            style={{
                width: "90%",
                margin: "0 auto",
                marginBottom: "3.5rem",
                borderRadius: borderRadius.card,
                background: themeColors.flashcardsLight,
                padding: `${spacing.SM} ${spacing.MD}`,
                gap: spacing.LG,
                justifyContent: "space-between",
                ...style,
            }}>
            <FlexRowAlignCenter
                className="bodyBold2"
                style={{
                    gap: spacing.MD,
                }}>
                You’re out of your 50 free Kai Complete suggestions, but you can still write yourself.
                <CircularRectTextButton
                    className="secondaryTextBold1"
                    onClick={() =>
                        openUpgradePopup({
                            event: UpgradeEvent.AUTOCOMPLETE,
                            context: {
                                itemId,
                                itemType,
                            },
                        })
                    }
                    style={{
                        backgroundColor: themeColors.primary3,
                        padding: `${spacing.XS} ${spacing.SM}`,
                        gap: spacing.XS,
                        color: themeColors.pureBlack,
                    }}>
                    <SparkleIcon size={24} />
                    Upgrade
                </CircularRectTextButton>
            </FlexRowAlignCenter>
            <CircularFilledIcon
                Icon={X}
                onClick={onClose}
                radius="4.4rem"
                primaryBg={themeColors.neutralBlack}
                primaryColor={themeColors.neutralWhite}
            />
        </FlexRowAlignCenter>
    );
};

export default KaiCompleteUpgradeBanner;
